import React, { useState, useEffect } from 'react';
import Header from '../../components/Header';
import './index.css';
import api from '../../services/api_despesas';
import styles from "./styles.module.css";
import { FaCloudDownloadAlt } from "react-icons/fa";
import fileDownload from 'js-file-download';

export default function RelatoriosReforma() {

    const [downloading, setDownloading] = useState(false);

    const [statusAut, setStatusAut] = useState({
        items: [
            { id: "0", text: "TODOS" },
            { id: "1", text: "AGUARDANDO AVALIAÇÃO" },
            { id: "2", text: "LIBERADO PELO GESTOR" },
            { id: "3", text: "REJEITADO PELO GESTOR" },
            { id: "4", text: "APROVADO PELA CONTROALDORIA" },
            { id: "5", text: "DEVOLVIDO" },
            { id: "6", text: "RECUSADO PELA CONTROLADORIA" },
        ],
        selectItem: '0'
    });

    const [tipoServ, setTipoServ] = useState({
        items: [
            { id: "0", text: "TODOS" },
            { id: "1", text: "INTERNO" },
            { id: "2", text: "EXTERNO" },
        ],
        selectItem: '0'
    });

    const [cenario, setCenario] = useState({
        items: [
        ],
        selectItem: '0'
    });

    useEffect(() => {
        api.get(`/cenario/getbyemp`).then(function (response) {
            if (response.data) {
                const cenarios = Object.assign([], cenario);
                cenarios.items = response.data;
                cenarios.selectItem = response.data[0].id;
                setCenario(cenarios);
            }
        }).catch(function (error) {
            // handle error
            alert(error);
            console.log(error);
        }).then(function () {
            // always executed
        });

    }, []);

    function handleSelectCombo(value, obj) {

        const comboSelected = Object.assign([], obj);
        comboSelected.selectItem = value;
        return comboSelected;

    }

    function handleReport() {
        var filtros = '';

        if (cenario.selectItem !== '0' && cenario.selectItem !== '') {
            if (filtros === '') {
                filtros = '?orc_cenarios_id=' + cenario.selectItem
            } else {
                filtros = filtros + '&orc_cenarios_id=' + cenario.selectItem
            }
        }

        if (statusAut.selectItem !== '0' && statusAut.selectItem !== '') {
            if (filtros === '') {
                filtros = '?status_aut=' + statusAut.selectItem
            } else {
                filtros = filtros + '&status_aut=' + statusAut.selectItem
            }
        }

        if (tipoServ.selectItem !== '0' && tipoServ.selectItem !== '') {
            if (filtros === '') {
                filtros = '?tipo_servico=' + tipoServ.selectItem
            } else {
                filtros = filtros + '&tipo_servico=' + tipoServ.selectItem
            }
        }

        if (!downloading) {
            setDownloading(true);


            api.get(`/reforma/relatorio${filtros}`
                , { responseType: 'blob' }
            ).then(function (response) {
                if (response.data) {

                    console.log(response.data);
                    if (response.data.erro) {
                        alert(response.data.erro)
                    } else {
                        fileDownload(response.data, 'RESUMO ORÇAMENTARIO REFORMA.pdf');
                    }
                }
            }).catch(function (error) {
                // handle error
                alert(error);
                console.log(error);
            }).then(function () {
                setDownloading(false);
                // always executed
            });
        }

    }

    function renderSpin() {
        if (downloading) {
            return (
                <div className={styles.divloading}>
                    <div className={styles.loading}></div>
                </div>
            )
        } else {
            return (
                <spam
                    className=" click btn btn-success "
                    onClick={() => handleReport()}
                >
                    <FaCloudDownloadAlt /> DOWNLOAD
                </spam>
            )
        }
    }

    return (
        <div className="container-lg">
            <Header title="RELATÓRIOS PREVISÃO DE REFORMA" />
            <div className={styles.divfiltrosrelatorio}>
                <div>
                    <label><b>CENARIO:</b></label>
                    <select
                        className="col-md-12 combobox  edit form-control"
                        id="cenario"
                        value={cenario.selectItem}
                        onChange={(e) => setCenario(handleSelectCombo(e.target.value, cenario))}
                    // ref={tipoRef}
                    // onKeyDown={(e) => handledown(e, etapaRef)}
                    >
                        {cenario.items.map((item, index) => (
                            <option key={index} value={item.id}>{item.text}</option>
                        ))}
                    </select>
                </div>
                <div>
                    <label>STATUS</label>
                    <select
                        className="col-md-12 combobox  edit form-control"
                        id="tipo"
                        value={statusAut.selectItem}
                        onChange={(e) => setStatusAut(handleSelectCombo(e.target.value, statusAut))}
                    >
                        {statusAut.items.map((item, index) => (
                            <option key={index} value={item.id}>{item.text}</option>
                        ))}
                    </select>
                </div>

                <div>
                    <label>TIPO SERVIÇO</label>
                    <select
                        className="col-md-12 combobox  edit form-control"
                        id="tipo"
                        value={tipoServ.selectItem}
                        onChange={(e) => setTipoServ(handleSelectCombo(e.target.value, tipoServ))}
                    >
                        {tipoServ.items.map((item, index) => (
                            <option key={index} value={item.id}>{item.text}</option>
                        ))}
                    </select>
                </div>
            </div>
            <div className={styles.buttondownload}>
                {renderSpin()}
            </div>

        </div>
    )
}